import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import { formatDate } from '../../utils/helper';

const AddUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [phoneCode, setPhoneCode] = useState('+353');
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    gender: 'male',
    date_of_birth: '',
    address: '',
    status: true,
    password: '',
    confirm_password: '',
  });

  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `admin/customers/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const userData = data.data; 
        
        let pCode = '+353';
        let pNumber = userData.phone || '';
        if (userData.phone && userData.phone.startsWith('+')) {
             if(userData.phone.startsWith('+353')) {
                 pCode = '+353';
                 pNumber = userData.phone.substring(4);
             } else {
                 const match = userData.phone.match(/^(\+\d{1,4})(\d+)$/);
                 if (match) {
                     pCode = match[1];
                     pNumber = match[2];
                 }
             }
        }
        setPhoneCode(pCode);

        setFormData({
          name: userData.name || '',
          email: userData.email || '',
          phone: pNumber,
          gender: userData.gender || 'male',
          date_of_birth: formatDate(userData.date_of_birth,'YYYY-MM-DD') || '',
          address: userData.address || '',
          status: userData.is_active !== undefined ? userData.is_active : true,
          password: '',
          confirm_password: '',
        });
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to load customer data');
    } finally {
      setIsLoader(false);
    }
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password && formData.password !== formData.confirm_password) {
        toast.error("Passwords do not match");
        return;
    }

    setIsLoader(true);
    try {
        const payload = { ...formData };
        if (!payload.password) {
            delete payload.password;
            delete payload.confirm_password;
        }

      const response = await ApiService.request({
        method: id ? 'PUT' : 'POST',
        url: id ? `admin/customers/${id}` : 'admin/customers',
        data: payload,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/customers');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Failed to save customer');
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit Customer' : 'Add Customer'}
            </h1>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3">
            <Link to="/customers" className="btn btn-sm fw-bold btn-secondary">
              Back
            </Link>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-fluid">
          <div className="card">
            <div className="card-body py-4">
              {isLoader ? (
                <Loader />
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label required">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label required">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Phone</label>
                      <div className="input-group">
                        <input 
                            type="text" 
                            className="form-control form-control-solid w-80px" 
                            value={phoneCode}
                            onChange={(e) => setPhoneCode(e.target.value)}
                            placeholder="+353"
                            style={{ maxWidth: '80px' }}
                        />
                        <input
                            type="text"
                            className="form-control"
                            name="phone"
                            value={formData.phone}
                            onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, '');
                                setFormData({...formData, phone: val});
                            }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date of Birth</label>
                      <input
                        type="date"
                        className="form-control border border-2"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                     <div className="col-md-6 mb-3">
                      <label className="form-label">Gender</label>
                      <select
                        className="form-select"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                      >
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        minLength="6"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        className="form-control"
                        name="confirm_password"
                        value={formData.confirm_password}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mb-3 form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="status"
                      name="status"
                      checked={formData.status}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="status">
                      Active
                    </label>
                  </div>

                  <button type="submit" className="btn btn-base">
                    {id ? 'Update' : 'Submit'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdate;
